
define('inlineSvg!svgs/icon/market-up', function () {return '<span class="inline-market-up inline-icon"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="11" viewBox="0 0 15 11"><path fill="#298422" d="M0 9.97L1.03 11H14l1-1L8 0h-.958L0 9.984z"/></svg></span>';});

